import { render, staticRenderFns } from "./TenantLogo.vue?vue&type=template&id=74188a26"
import script from "./TenantLogo.vue?vue&type=script&lang=js"
export * from "./TenantLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports